import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
// import botDetector from '../lib/bot-detector'
import { getUuid } from '../module';
import { getAllData } from './getAllData';
import { get, isUndefined, isBoolean } from '../helper/utils/try';
import { checkAllValues, filterConfigExtraValues, randomString } from '../helper/utils/common';
import { request } from './sendRequest';
import { getLocation as _getLocation, getFingerprintData } from '../module';
import { getRearrangeData } from './getRearrangeData';
import { getAfiData } from './getAfiData';
import CryptoJs from '../plugins/useCryptoJs';
import { asyncBotDetector } from '../plugins/useBotDetector';
import { setTmx } from '../plugins/useTmx';
var resolveUuidPromise, resolveDataPromise, resolveSmDeviceIdPromise, resolveAfiDataPromise;
var uuidPromise = new _Promise(function (resolve) {
  resolveUuidPromise = resolve;
});
var dataPromise = new _Promise(function (resolve) {
  resolveDataPromise = resolve;
});
var smDeviceIdPromise = new _Promise(function (resolve) {
  resolveSmDeviceIdPromise = resolve;
});
var afiDataPromise = new _Promise(function (resolve) {
  resolveAfiDataPromise = resolve;
});
/**
 * 提供调用的方法
 * getCurrentUuid 获取uuid 依赖init方法
 * getCurrentData 获取设备信息 依赖init方法
 * getDeviceId 获取device id
 * getLocation 获取地理位置
 */

export var getCurrentUuid = function getCurrentUuid() {
  return uuidPromise;
};
export var getCurrentData = function getCurrentData() {
  return dataPromise;
};
export var getAllDeviceData = function getAllDeviceData() {
  return deviceValues;
};
export var getSmDeviceId = function getSmDeviceId() {
  return smDeviceIdPromise;
};
export var getAfiDataInfo = function getAfiDataInfo() {
  return afiDataPromise;
};
export var getDeviceId = function getDeviceId() {
  return new _Promise(function (resolve) {
    getFingerprintData().then(function (res) {
      resolve(res.fingerprint2Murmur || res.device_id || '');
    });
  });
};
export var getLocation = function getLocation() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    timeout: 5000,
    maximumAge: 5000
  };
  return new _Promise(function (resolve) {
    _getLocation({
      timeout: props.timeout,
      maximumAge: props.maximumAge
    }).then(function (res) {
      resolve(res);
    });
  });
};
export var getTmx = function getTmx() {
  var page_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return setTmx(page_id);
};

var __config,
    //用户配置
deviceValues = {},
    //设备数据
locationInfo = {},
    isMoveResponse = 0;
/**
 * 异步upload方法，可自行调用触发上报
 * @param {object} uploadConfig
 */


export var uploadData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var uploadConfig,
        deviceData,
        data,
        cover_config,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            uploadConfig = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _context.next = 3;
            return getCurrentData();

          case 3:
            deviceData = _context.sent;
            data = _objectSpread(_objectSpread({}, deviceData), {}, {
              broswer: _objectSpread(_objectSpread({}, deviceData.broswer), {}, {
                is_move: isMoveResponse //通过触发回调更改的值

              }),
              post_timestamp: new Date().getTime(),
              //上报时刻
              adjust_timestamp: new Date().getTime()
            }, filterConfigExtraValues({
              extra: _objectSpread(_objectSpread({}, __config.extra), uploadConfig.extra)
            }) || {});
            cover_config = _objectSpread(_objectSpread({}, __config), uploadConfig);

            if (cover_config === null || cover_config === void 0 ? void 0 : cover_config.reportIsEncrypt) {
              data = {
                para: CryptoJs.getEncrypt(_objectSpread({}, data))
              };
            }

            request({
              config: __config,
              uploadConfig: uploadConfig,
              deviceValues: _objectSpread({}, data)
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadData() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * init方法
 * @param {object} config 用户配置
 */

export var init = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _deviceValues, _deviceValues2, _deviceValues2$sd_ext;

    var config,
        allData,
        rearrangeData,
        isMoveResult,
        trace_id,
        dataIsEncrypt,
        uuidResponse,
        afiData,
        _data,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            config = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            __config = config; //获取所有异步数据

            _context2.next = 4;
            return getAllData({
              config: __config
            });

          case 4:
            allData = _context2.sent;
            //重置数据为上报格式
            rearrangeData = getRearrangeData({
              config: __config,
              values: allData
            }); //调用判断是否为机器人

            _context2.next = 8;
            return asyncBotDetector();

          case 8:
            isMoveResult = _context2.sent;
            isMoveResponse = _typeof(isBoolean(isMoveResult === null || isMoveResult === void 0 ? void 0 : isMoveResult.isBot)) ? !!isMoveResult.isBot ? 1 : 0 : 0;
            deviceValues = _objectSpread(_objectSpread({}, rearrangeData), {}, {
              post_timestamp: new Date().getTime(),
              //上报时刻
              adjust_timestamp: new Date().getTime(),
              //上报时刻
              broswer: _objectSpread(_objectSpread({}, rearrangeData.broswer), {}, {
                is_move: isMoveResponse
              })
            }); //加密加压

            trace_id = randomString(21) + new Date().getTime();
            dataIsEncrypt = CryptoJs.getEncrypt({
              deviceId: (_deviceValues = deviceValues) === null || _deviceValues === void 0 ? void 0 : _deviceValues.device_id,
              fingerprint: deviceValues,
              trace_id: trace_id
            }); //回调获取uuid

            _context2.next = 15;
            return getUuid({
              para: dataIsEncrypt
            }, config);

          case 15:
            uuidResponse = _context2.sent;
            resolveUuidPromise(uuidResponse !== null && uuidResponse !== void 0 ? uuidResponse : '');
            deviceValues = _objectSpread(_objectSpread({}, deviceValues), {}, {
              uuid: uuidResponse
            }); //校验所有上报信息

            checkAllValues(deviceValues); //返回所有设备数据

            resolveDataPromise(deviceValues); //返回数美di

            resolveSmDeviceIdPromise(((_deviceValues2 = deviceValues) === null || _deviceValues2 === void 0 ? void 0 : (_deviceValues2$sd_ext = _deviceValues2.sd_ext) === null || _deviceValues2$sd_ext === void 0 ? void 0 : _deviceValues2$sd_ext.sm_device_id) || ''); //返回欧洲收口设备数据

            afiData = getAfiData(deviceValues);
            resolveAfiDataPromise(afiData); //判断是否在init后执行上报，根据config中reportAfterInited值

            if (!(!config.reportAfterInited && !isUndefined(config.reportAfterInited))) {
              _context2.next = 25;
              break;
            }

            return _context2.abrupt("return");

          case 25:
            _data = deviceValues;

            if (config === null || config === void 0 ? void 0 : config.reportIsEncrypt) {
              _data = {
                para: CryptoJs.getEncrypt(_objectSpread({}, _data))
              };
            } //调用上报方法


            request({
              config: config,
              deviceValues: _objectSpread({}, _data)
            });

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function init() {
    return _ref2.apply(this, arguments);
  };
}();